import { Component, Input } from '@angular/core';

import {
    FoundDocument, landscapeLabel
} from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

@Component({
    selector: 'df-doc-row',
    templateUrl: './df-doc-row.component.html',
    styleUrls: ['./df-doc-row.component.scss'],
    standalone: false
})
export class DfDocRowComponent {
    public readonly landscapeLabel = landscapeLabel;
    @Input({ required: true }) doc!: FoundDocument;
    @Input() compact: boolean = false;

    constructor(public df: DocumentFinderService) {}

    public get decision() { return this.df.decisions[this.doc.id]; }
    public get selected(): boolean { return this.df.selection.has(this.doc.id); }
    public get reason(): string | undefined { return this.df.reasonOf(this.doc); }
    public get byAgent(): boolean { return this.doc.agent === 'exc' && !this.df.reasons[this.doc.id]; }
    public get lastFolder(): string { return this.doc.path.split(' › ').slice(-1)[0]; }

    public onSelect(checked: boolean): void {
        this.df.toggleSelect(this.doc.id, checked);
    }

    public open(): void {
        this.df.openDrawer(this.doc.id);
    }

    public include(): void {
        this.df.include(this.doc.id);
    }

    public exclude(): void {
        this.df.openExclude([this.doc.id]);
    }
}
